import * as types from './shipmentStatusActionTypes';

const initialState = {
  shipmentStatusData: null,
  shipmentStatusList: null,
  shipmentStatusSortData: null,
  createShipmentStatusData: null,
  createShipmentStatusError: null,
  updateShipmentStatusData: null,
  updateShipmentStatusError: null,
  deleteShipmentStatusData: null,
  deleteShipmentStatusError: null,
  error: {
    type: null,
    data: null,
  },
};

export const shipmentStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_SHIPMENT_STATUS_DATA:
      return {
        ...state,
        shipmentStatusData: action.payload || null,
        shipmentStatusList: action.payload?.ShipmentStatusList || [],
      };

    case types.GET_SHIPMENT_STATUS_ERROR:
      return {
        ...state,
        error: {
          type: types.GET_SHIPMENT_STATUS_ERROR,
          data: action.payload,
        },
      };

    case types.SET_SHIPMENT_SORT_DATA:
      return {
        ...state,
        shipmentStatusSortData: {
          orderBy: action.payload.orderBy,
          order: action.payload.order,
        },
      };

    case types.CREATE_SHIPMENT_STATUS_REQUEST:
      return {
        ...state,
        createShipmentStatusError: null,
      };

    case types.CREATE_SHIPMENT_STATUS_DATA:
      return {
        ...state,
        createShipmentStatusData: action.payload,
        createShipmentStatusError: null,
      };

    case types.CREATE_SHIPMENT_STATUS_ERROR:
      return {
        ...state,
        createShipmentStatusData: null,
        createShipmentStatusError: action.payload,
      };

    case types.UPDATE_SHIPMENT_STATUS_REQUEST:
      return {
        ...state,
        updateShipmentStatusError: null,
      };

    case types.UPDATE_SHIPMENT_STATUS_DATA:
      return {
        ...state,
        updateShipmentStatusData: action.payload,
        updateShipmentStatusError: null,
      };

    case types.UPDATE_SHIPMENT_STATUS_ERROR:
      return {
        ...state,
        updateShipmentStatusData: null,
        updateShipmentStatusError: action.payload,
      };

    case types.DELETE_SHIPMENT_STATUS_REQUEST:
      return {
        ...state,
        deleteShipmentStatusError: null,
      };

    case types.DELETE_SHIPMENT_STATUS_DATA:
      return {
        ...state,
        deleteShipmentStatusData: action.payload,
        deleteShipmentStatusError: null,
      };

    case types.DELETE_SHIPMENT_STATUS_ERROR:
      return {
        ...state,
        deleteShipmentStatusData: null,
        deleteShipmentStatusError: action.payload,
      };

    default:
      return state;
  }
};
